import * as React from 'react';

import { PercentageDiscountIcon } from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { ProductDiscount } from './ProductDiscount';
import {
  VoucherDiscountInfoWrapper,
  VoucherDiscountIconWrapper,
} from './styled';

export interface IVoucherDiscountInfoProps {
  highlightedDiscountAmount: string | JSX.Element;
  instructionsText: JSX.Element;
  infoTooltipText: JSX.Element;
  discountCode: string;
  percentage: number;
  isUnderSelectBox?: boolean;
  showPercentageIcon: boolean;
  highlightedDiscountAmountColor?: string;
}

export const VoucherDiscountInfo: React.FC<IVoucherDiscountInfoProps> = ({
  showPercentageIcon,
  percentage,
  isUnderSelectBox,
  ...props
}) => {
  const newDesign = useNewPdDesignEnabled();

  return (
    <VoucherDiscountInfoWrapper
      newDesign={newDesign}
      isUnderSelectBox={isUnderSelectBox}
    >
      <ProductDiscount {...props} />

      {showPercentageIcon && (
        <VoucherDiscountIconWrapper
          data-testid="voucher-discount-icon"
          hideDesktop={false}
        >
          <PercentageDiscountIcon percentage={percentage} />
        </VoucherDiscountIconWrapper>
      )}
    </VoucherDiscountInfoWrapper>
  );
};
